import { useQuery } from '@tanstack/react-query';
import { useUser } from '../../../contexts/UserContext';
import { useApiManager } from '../../../hooks';
import { MAX_PERSONAL_MEETINGS } from '../helpers/constants';

const SCHEDULE_LIMITS_QUERY_KEY = ['schedule', 'limits'] as const;

/**
 * Hook to fetch schedule limits (e.g., max personal meetings) from the API
 * Falls back to the hardcoded MAX_PERSONAL_MEETINGS value if API call fails or returns no value
 */
const useScheduleLimits = () => {
  const apiManager = useApiManager();
  const { isAuthenticated } = useUser();

  const queryResult = useQuery({
    queryKey: SCHEDULE_LIMITS_QUERY_KEY,
    queryFn: async () => {
      const response = await apiManager.ownership.getScheduleLimits();
      return response;
    },
    enabled: isAuthenticated,
    staleTime: Number.POSITIVE_INFINITY,
    refetchOnWindowFocus: false,
  });

  // Extract max_personal_room_count from response, fallback to hardcoded value
  const maxPersonalMeetings = queryResult.data?.max_personal_room_count ?? MAX_PERSONAL_MEETINGS;

  return {
    maxPersonalMeetings,
    isLoading: queryResult.isLoading,
    isError: queryResult.isError,
    error: queryResult.error,
  };
};

export default useScheduleLimits;
